import {mediaQueryStyles as mq} from '@newsela/angelou';
import {css} from 'emotion';

export const logoMarkStyle = (showFullSize, fullSizeMediaQuery) => {
  const fullSizeStyles = {
    width: '151px',
  };
  const smallSizeStyle = {
    width: '32px'
  };

  let query = fullSizeMediaQuery;
  if (showFullSize !== undefined) {
    if (showFullSize) {
      query = mq.mediaQuery.downTo(0);
    } else {
      query = mq.mediaQuery.downTo(Infinity);
    }
  }
  return css({
    'svg:first-child': {
      ...fullSizeStyles,
      display: 'none',
      [query]: {
        display: 'inline'
      }
    },
    'svg:nth-child(2)': {
      ...smallSizeStyle,
      [query]: {
        display: 'none'
      }
    }
  });
};
